module.exports = __webpack_public_path__ + "img/sbi.bcf99957.jpg";